import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';

@Directive({
  selector: '[appSlugInput]',
  standalone: true
})
export class SlugInputDirective implements AfterViewInit {
  @Input() sourceInput?: HTMLInputElement; // The other input supplying initial value
  lastBeforeInputSlug: string = '';

  constructor(private el: ElementRef, private ngControl: NgControl) {}

  ngAfterViewInit() {
    if (!this.sourceInput) {
      console.error("Yeah doesn't exist");
      return;
    };

    // If the input starts empty and there's a source input, generate the initial value
    if (!this.el.nativeElement.value) {
      this.el.nativeElement.value = this.generateSlug(this.sourceInput.value);
      this.ngControl.control?.setValue(this.el.nativeElement.value);
    }

    this.sourceInput.addEventListener('beforeinput', (ev) => { this.lastBeforeInputSlug = this.generateSlug(this.sourceInput!.value); });
    this.sourceInput.addEventListener('input', (test) => { console.log(test); this.onSourceInput(this.sourceInput!.value); });
  }

  onSourceInput(title: string) {
    console.info(this.onSourceInput.name);
    const slugValue = this.generateSlug(this.el.nativeElement.value);
    const proposedSlugValue = this.generateSlug(title);
    if (this.el.nativeElement.value.trim() != '' && this.lastBeforeInputSlug != slugValue) {
      return;
    }
    this.ngControl.control?.setValue(proposedSlugValue);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const slugValue = this.generateSlug(inputElement.value);
    inputElement.value = slugValue;
    this.ngControl.control?.setValue(slugValue);
  }

  private generateSlug(value: string): string {
    return value
      .normalize('NFD') // Normalize diacritics
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^a-zA-Z0-9]+/g, '-') // Replace non-alphanumeric with dashes
      //.replace(/^-+|-+$/g, '') // Trim leading/trailing dashes
      .toLowerCase();
  }
}
